import { Card, Skeleton } from "../../design-system";

/** Placeholder shaped like a titled panel of ranked bars. */
export function PanelSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <Card padding="none" className="flex flex-col">
      <div className="px-5 pt-4">
        <Skeleton className="h-4 w-36" />
      </div>
      <div className="p-5 pt-4">
        <BarsSkeleton rows={rows} />
      </div>
    </Card>
  );
}

/** Placeholder for a list of ranked bars. */
export function BarsSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-9 w-full" />
      ))}
    </div>
  );
}

/** Placeholder for a chart block. */
export function ChartSkeleton({ height = 224 }: { height?: number }) {
  return <Skeleton className="w-full" style={{ height }} />;
}

/** Placeholder row of KPI cards. */
export function KpiSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-lg border bg-surface p-4 shadow">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-4 h-8 w-28" />
          <Skeleton className="mt-4 h-8 w-full" />
        </div>
      ))}
    </div>
  );
}
